import React from "react";
import { cn } from "../lib/utils";

export function LoadingSpinner({ className, size = "default" }) {
  return (
    <div
      className={cn(
        "animate-spin rounded-full border-2 border-gray-300 border-t-emerald-600",
        {
          "h-4 w-4": size === "sm",
          "h-6 w-6": size === "default",
          "h-8 w-8": size === "lg",
          "h-12 w-12": size === "xl",
        },
        className
      )}
    />
  );
}

export function LoadingCard({ children, className }) {
  return (
    <div className={cn("flex items-center justify-center p-8", className)}>
      <div className="text-center">
        <LoadingSpinner size="lg" className="mx-auto mb-4" />
        <p className="text-gray-600">{children || "Loading..."}</p>
      </div>
    </div>
  );
}

export function LoadingPage({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="xl" className="mx-auto mb-4" />
        <p className="text-xl text-gray-600">{children || "Loading..."}</p>
      </div>
    </div>
  );
}